import { Flex, Image } from "@jewlr/storybook/core"
import { FocusScope } from "@react-aria/focus"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import styled from "styled-components"

import { updateTmpDiamond } from "areas/product/store/actions"
import {
  ChoiceOption,
  OptionTitle,
} from "areas/product/wizard-options/components"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import { useNavigation } from "helpers/use-navigation"
import { cn } from "styles/utils"

const StoneDataTable = styled.table`
  text-align: left;
  td {
    font-size: 11px;
    font-weight: 700;
    ${(props) => props.theme.mediaQueries.tablet`
      font-size: 13px;
    `}
  }
  tr {
    padding-bottom: 4px;
    margin-bottom: 6px;
  }
  tr:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  td:first-child {
    font-weight: 500;
    padding-right: 8px;
  }
`
const RecommendedStonesOptions = ({
  stone,
  diamond,
  selectedShape,
  addTmpDiamond,
  selectedTmpDiamond,
  index,
}) => {
  const keyboardProps = useNavigation({ direction: "horizontal" })
  const selected = selectedTmpDiamond?.recommendedIndex === index
  return (
    <ChoiceOption
      aria-checked={selected}
      className={cn(
        "border-grey-30 tablet:py-16 tablet:px-8 relative m-0 border px-4 py-8",
        selected && "border-selected border-2"
      )}
      data-cy={`diamon-selector-recommended-stone-${diamond.name}`}
      onClick={() => addTmpDiamond(diamond, index)}
      role="radio"
      tabIndex={selected ? 0 : -1}
      {...keyboardProps}
    >
      <Flex alignItems="center" height="12px" mb="6px">
        {diamond.the_one && (
          <Image
            alt="Jewlr"
            height="12px"
            mr="4px"
            src={require("images/layout/logo/jewlr-icon-logo-primary.svg")}
            width="12px"
          />
        )}{" "}
        <OptionTitle className="text-14 desktop:16 mb-0 mt-0 font-bold">
          {diamond.name}
        </OptionTitle>
      </Flex>
      <OptionTitle className="text-11 desktop:text-13 mb-0 mt-0">
        {diamond.description}
      </OptionTitle>
      <Flex alignItems="center">
        <Image
          alt={diamond.name}
          height="15px"
          mr="4px"
          src={`i${sl.config.jewlr_asset_url}mages/product/diamond/${selectedShape}/${selectedShape}_front.png`}
          srcSet={`${`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${selectedShape}_front.png`} 1x, ${`${sl.config.jewlr_asset_url}images/product/diamond/${selectedShape}/${selectedShape}_front_2x.png`} 2x`}
          width="auto"
        />
        <OptionTitle className="text-primary text-13 desktop:text-15">
          {to_currency(stone.price)}
        </OptionTitle>
      </Flex>
      <StoneDataTable>
        <tbody>
          <tr>
            <td>Carat</td>
            <td>{stone.carat}</td>
          </tr>
          <tr>
            <td>Cut</td>
            <td>{stone.cut}</td>
          </tr>
          <tr>
            <td>{jewlr_t("terms.Color")}</td>
            <td>{stone.color}</td>
          </tr>
          <tr>
            <td>Clarity</td>
            <td>{stone.clarity}</td>
          </tr>
          <tr>
            <td>Size</td>
            <td>≈ {stone.stone_size}</td>
          </tr>
        </tbody>
      </StoneDataTable>
    </ChoiceOption>
  )
}
RecommendedStonesOptions.propTypes = {
  addTmpDiamond: PropTypes.func,
  diamond: PropTypes.object,
  index: PropTypes.number,
  selectedShape: PropTypes.string,
  selectedTmpDiamond: PropTypes.object,
  stone: PropTypes.object,
}
const InternalRecommendedStones = ({
  addTmpDiamond,
  recommendedStones,
  selectedShape,
  selectedTmpDiamond,
}) => {
  return (
    <FocusScope>
      <div
        aria-labelledby="diamond-selector-choose_stone"
        className="desktop:px-12 desktop:gap-x-16 desktop:gap-y-24 mb-24 grid grid-cols-2 gap-x-8 gap-y-16 px-4"
        role="radiogroup"
      >
        {recommendedStones.map((diamond, index) => {
          let stone = diamond.stone
          return (
            <RecommendedStonesOptions
              addTmpDiamond={addTmpDiamond}
              diamond={diamond}
              index={index}
              key={`recommended_stone_${diamond.name}`}
              selectedShape={selectedShape}
              selectedTmpDiamond={selectedTmpDiamond}
              stone={stone}
            />
          )
        })}
      </div>
    </FocusScope>
  )
}

const mapStateToProps = (state) => {
  return {
    recommendedStones: state.diamondSelector.recommended_stones,
    selectedShape: state.choices.d_shape.value.toLowerCase(),
    selectedTmpDiamond: state.diamondUI.tmpDiamond,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addTmpDiamond: (diamond, index) => {
      dispatch(updateTmpDiamond({ ...diamond.stone, recommendedIndex: index }))
    },
  }
}

InternalRecommendedStones.propTypes = {
  addTmpDiamond: PropTypes.func,
  recommendedStones: PropTypes.array,
  selectedShape: PropTypes.string,
  selectedTmpDiamond: PropTypes.object,
}

const RecommendedStones = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalRecommendedStones)

export default RecommendedStones
